import axios from '@/plugins/axios';
import utils from '@/stores/utils';
import { CSV_EXPORT_LIMIT } from '@/constants/csv-export';
    import $utils from '@/utils';

const state = {
    producttypes: [],
    producttypes_count: 0,
    producttypes_loading: false,
    producttypes_loaded: false,
    producttypes_loading_errors: null,
    producttypes_cancel_source: null,
    producttype_deleting: false,
    producttype_deleting_errors: null,
};

const mutations = {
    updateProductTypes(state, producttypes) {
        state.producttypes = producttypes;
    },
    updateProductTypesCount(state, count) {
        state.producttypes_count = count;
    },
    updateProductTypesLoading(state, loading) {
        state.producttypes_loading = loading;
    },
    updateProductTypesLoaded(state, loaded) {
        state.producttypes_loaded = loaded;
    },
    updateProductTypesLoadingErrors(state, errors) {
        state.producttypes_loading_errors = errors;
    },
    updateProductTypeDeleting(state, deleting) {
        state.producttype_deleting = deleting;
        state.producttype_deleting_errors = null;
    },
    updateProductTypeDeletingErrors(state, errors) {
        state.producttype_deleting_errors = errors;
        state.producttype_deleting = false;
    },
    updateProductTypesCancelSource(state, cancel_source) {
        state.producttypes_cancel_source = cancel_source;
    },
};


const actions = {

    async fetchProductTypes({ commit, dispatch, state }, params) {
        commit('updateProductTypesLoading', true);
        commit('updateProductTypesLoadingErrors', null);

        if (state.producttypes_cancel_source) {
            state.producttypes_cancel_source.cancel("canceled");
        }

        const cancelSource = axios.CancelToken.source();
        commit('updateProductTypesCancelSource', cancelSource);

        try {
            const response = await axios.get('/api/producttypes/', {
                params: { ordering: 'label' },
                cancelToken: state.producttypes_cancel_source?.token
            });
            commit('updateProductTypes', response.data.results);
            commit('updateProductTypesCount', response.data.count);
            commit('updateProductTypesLoading', false);
            commit('updateProductTypesLoaded', true);
            commit('updateProductTypesCancelSource', null);
            return response;
        } catch (xhr_error) {
            if (axios.isCancel(xhr_error)) {
                return;
            }
            const error = utils.handleError(xhr_error);
            commit('updateProductTypesLoadingErrors', error.details);
            commit('updateProductTypesLoading', false);
            throw error;
        }
    },

    async deleteProductType({ commit, dispatch, state }, params) {
        commit('updateProductTypeDeleting', true);
        commit('updateProductTypeDeletingErrors', null);

        const url = `/api/producttypes/${params.instance.id}/`;
        try {
            const response = await axios.delete(url);
            commit('updateProductTypeDeleting', false);
            dispatch('fetchProductTypes');
            return response;
        } catch (xhr_error) {
            const error = utils.handleError(xhr_error);
            commit('updateProductTypeDeleting', false);
            commit('updateProductTypeDeletingErrors', error.details);
            throw error;
        } finally {
            dispatch('session/fetchStats', null, { root: true });
        }
    },

    exportProductTypesAsCSV({ commit, dispatch, state }, params) {
        let filters = {
            format: 'csv',
            limit: CSV_EXPORT_LIMIT,
        };
        
        if (params && params.filtered) {
            // If filtered export is requested, use current filters
            filters = Object.assign({}, filters, {
                ordering: 'label',
            });
        }
        
        $utils.downloadFile({
            url: "/api/producttypes/",
            params: filters,
        }, $utils.getFilename('productTypes'));
    },

};

export default {
    namespaced: true,
    state,
    actions,
    mutations,
};
